<dl class="hvac-stat">
    <dt class="hvac-label-sm hvac-rhythm-1">{{label}}</dt>
    <dd class="hvac-stat-value hvac-fw-bd">{{value}}</dd>
</dl>
